const getFlowUsages = state => state.automationTab.flowUsages.flows;
export default getFlowUsages;